export default __webpack_public_path__ + "static/media/img_04.0ac2569b.jpg";